export const EVENT_BUS_SESSION_WEBHOOKS_CHANGED = 'gd.session.webhooks:change'
